<template>
  <div class="wrapper box box_v">
    <Spin size="large" fix v-if="isLoaidng"></Spin>
    <div class="title">
      <span>{{$route.query.deptName}}</span>
      <div class="right">
        <!-- <Button @click.native="handleClickSearch"  :loading="isLoading1" style="margin-right:20px">搜索</Button> -->
        <Button @click="handleClickAsync" type="primary">同步到同类别部门</Button>
      </div>
      <div class="left">
        <Icon
          @click="$router.push({name: 'Department'})"
          :size="34"
          style="cursor:pointer"
          color="#999999"
          type="ios-arrow-back"
        />
        <ButtonGroup shape="circle">
          <Button  @click="handleClickMoudle(0)" :type="index === 0 ? 'primary': 'default'">{{moduleName_1}}</Button>
          <Button @click="handleClickMoudle(1)" :type="index === 1 ? 'primary': 'default'">{{moduleName_2}}</Button>
        </ButtonGroup>
      </div>
    </div>
    <!-- @dragstart="onDragStart($event,index)"
        @dragover="onDragOver($event,index)"
        @dragend="onDropEnd"
    draggable-->
    <div class="card-wrapper">
      <div v-for="(item,index) in list" class="drag-wrapper" :key="item.id">
        <Card :padding="0">
          <div class="card box box_v">
            <div class="box card-top">
              <div>{{item.moduleName}}</div>
              <i-switch
                v-model="item.isShow"
                :true-value="1"
                :false-value="0"
                @on-change="change(index)"
              />
            </div>
            <div class="card-remark">{{item.remark}}</div>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../../api/index";
const { getMiniSet, syncCommonTpyeDept } = api;
const throttle = (fn, delay) => {
  let time = () => new Date().getTime();
  let old = time();
  return (...rest) => {
    if (time() - old > delay) {
      fn(...rest);
      old = time();
    }
  };
};
export default {
  data() {
    return {
      index: 0,
      moduleName_1: '',
      moduleName_2: '',
      column: 3,
      height: 180,
      list: [],
      isLoaidng: false
    };
  },
  computed: {
    columnWidth() {
      return (0.9 / this.column) * 100 + "%";
    }
  },
  methods: {
    init() {
      let fn = (start, target) => {
        if (start > target) {
          // 如果移动项在目标项后面，那么从目标项到移动项都向后移动一步
          this.list.splice(target, 0, ...this.list.splice(start, 1));
        }
        if (start < target) {
          // 如果移动项在目标项前面，那么从移动项到目标项都向前移动一步
          this.list.splice(
            start,
            0,
            ...this.list.splice(start + 1, target - start)
          );
        }
        // 更新上一次的位置
        this.oldIndex = target;
        // 更新起始位置
        this.startIndex = target;
      };
      this.exchange = throttle(fn, 100);
    },
    onDropEnd(event) {
      // event.target.style.opacity = ''
      console.log("jieshu ");
      this.changeSort();
    },
    onDragOver(event, index) {
      event.preventDefault();
      this.exchange(this.startIndex, index);
    },
    onDragStart(event, index) {
      // event.target.style.opacity = .5
      event.dataTransfer.dropEffect = "move";
      this.startIndex = index;
    },
    change(index) {
      this.isLoaidng = true;
      try {
        var item = this.list[index];
        var url = api.setMiniSet;
        this.$post(url, {
          id: item.id,
          isShow: item.isShow ? 1 : 0
        }).then(res => {
          this.$Message.success("操作成功");
          //   this.$store.commit("updateShequSideBar", JSON.stringify(this.list));
        });
      } finally {
        this.isLoaidng = false;
      }
    },
    changeSort() {
      var id = this.list.map((item, index) => {
        return {
          id: item.id,
          sortNo: index
        };
      });
      this.$post(this.urlobj.sortList, id).then(res => {
        this.$store.commit("updateShequSideBar", JSON.stringify(this.list));
      });
    },
    handleClickAsync() {
      let that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "确定要将权限同步到同类别部门吗",
        async onOk() {
          that.isLoaidng = true;
          try {
            let res = await that.$post(syncCommonTpyeDept, {
              deptId: that.$route.query.id
            });
            that.$Message.success("同步成功");
          } finally {
            that.isLoaidng = false;
          }
        }
      });
    },
    handleClickMoudle(index) {
      this.index= index
      this.getSettings()
    },
    async getSettings() {
      this.isLoaidng = true;
    try {
      let res = await this.$get(getMiniSet, {
        deptId: this.$route.query.id
      })

      let manager, application
      res.rows[0].pc.forEach(item => {
        if(item.moduleValue == 'page_community_management'){
          manager = item
        }
        if(item.moduleValue == "page_community_application"){
          application = item
        }
      })


      this.moduleName_1 = application ? application.moduleName : ''
      this.moduleName_2 = manager ? manager.moduleName : ''
      
      this.list = this.index === 0 ?application.children : manager.children
      this.init();
    } finally {
      this.isLoaidng = false;
    }
    }
  },

  mounted() {
    //   this.list = JSON.parse(this.$store.state.shequSideBar)
    this.getSettings()
    
  }
};
</script>


<style scoped lang="less">
.wrapper {
  height: 100%;
}

.mini-header-wrapper {
  display: flex;
  line-height: 30px;
  padding: 30px 0;
  justify-content: center;
  position: relative;
  font-size: 25px;
  text-align: center;
}

.card-wrapper {
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px;
}
.drag-wrapper {
  margin-right: 20px;
  margin-bottom: 20px;
}
.card {
  padding: 0 20px;
  justify-content: center;
  height: 120px;
  width: 370px;
  box-sizing: border-box;
}
.card-top {
  justify-content: space-between;
  margin-bottom: 20px;
  font-size: 18px;
}
.card-remark {
  color: #999;
  font-size: 16px;
}
.title {
  text-align: center;
  height: 85px;
  line-height: 85px;
  font-size: 24px;
  font-weight: bold;
  position: relative;
  .right {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
  }
  .left {
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
  }
}
</style>
